import { render, staticRenderFns } from "./InflatedMark.vue?vue&type=template&id=3842e26e&scoped=true&"
import script from "./InflatedMark.vue?vue&type=script&lang=js&"
export * from "./InflatedMark.vue?vue&type=script&lang=js&"
import style0 from "./InflatedMark.vue?vue&type=style&index=0&id=3842e26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842e26e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VSubheader})
